export default __webpack_public_path__ + "static/media/background-landing-2.7f7056bf.jpg";